import { FeesRepo } from '@services/fees.repo';
import * as moment from 'moment'
import { extractErrorMessage } from '@common/utils/errorUtils';


class GenerateInstructionSheetDialogController implements ng.IOnInit{

  public valueDate: any;
  public currentDate : Date;

  public isLoading : boolean = false;
  public selectedInstructions;


   /** @ngInject */
   constructor(private $mdDialog: angular.material.IDialogService, private notifyjs, private $scope: angular.IScope, private feesRepo : FeesRepo, private $window: angular.IWindowService) { }

   $onInit() {
    this.currentDate = new Date(this.formatDate(this.currentDate))
    this.valueDate = this.currentDate;
  }


  generateFeeInstruction = () => {
    const form = (this.$scope as any).reportForm;
    if (form && form.$invalid) {
      return;
    }
    
    this.isLoading = true;
    this.valueDate = this.formatDate(this.valueDate);
    this.feesRepo.generateInstructions(this.selectedInstructions, this.valueDate)
        .then(res => {
          let instructionExcel = res.data as any;
          this.$window.open(instructionExcel.url, '_blank');
          this.$mdDialog.hide(true)
        })
        .catch((err) => {
          this.notifyjs("Failed to generate instruction. " + extractErrorMessage(err))
        })
        .finally(() => this.isLoading = false)
  }

  formatDate(selectedDate) {
    return moment(selectedDate).format('YYYY-MM-DD');
  }

  cancel = () => {
    this.$mdDialog.hide(false);
  }

}



export const generateInstructionSheetDialog: angular.IComponentOptions = {
  template: require('./fees.instruction.generateInstructionSheet.dialog.html'),
  controller: GenerateInstructionSheetDialogController,
  bindings: {
    selectedInstructions: "<",
    restrictedDates: "<"
  }
}



// WEBPACK FOOTER //
// ./src/app/fees/instructions/finalrun/generateInstructionSheetDialog/instruction.generateInstructionSheet.dialog.ts